import { render, staticRenderFns } from "./WarehouseTabs.vue?vue&type=template&id=1bc04922"
import script from "./WarehouseTabs.vue?vue&type=script&lang=js"
export * from "./WarehouseTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports